import { render } from "./DashboardSearchMaxLimitReached.vue?vue&type=template&id=77101901&ts=true"
import script from "./DashboardSearchMaxLimitReached.vue?vue&type=script&lang=ts"
export * from "./DashboardSearchMaxLimitReached.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__